import { useCallback, useRef, useState } from 'react';

const useTouchResizeHandler = (resizeHandler: (event: React.MouseEvent | React.TouchEvent) => void) => {
  const [isActive, setIsActive] = useState(false);
  const touchActiveRef = useRef(false);

  const onTouchStart = useCallback(
    (event: React.TouchEvent) => {
      event.stopPropagation();
      event.preventDefault();
      touchActiveRef.current = true;
      setIsActive(true);
      resizeHandler(event);
    },
    [resizeHandler],
  );

  const onTouchMove = useCallback((event: React.TouchEvent) => {
    if (!touchActiveRef.current) return;
    event.preventDefault();
  }, []);

  const onTouchEnd = useCallback(() => {
    touchActiveRef.current = false;
    setIsActive(false);
  }, []);

  return { onTouchStart, onTouchMove, onTouchEnd, isActive };
};

export default useTouchResizeHandler;
